<template>
	<section :class="['block-wrapper', hasLocalVideo, componentClass, colorMode, {visible: visible, ready: ready}]">
		
		<div v-if="data.local_video" :class="['background-video-wrapper', 'large', 'swipe-in-target']">
			<background-video 
				v-if="data.local_video" 
				:video="data.local_video">
			</background-video>
			
			<background-video-vimeo 
				v-if="data.bg_video_id" 
				:id="data.bg_video_id" 
				:image="data.video_fallback_image">
			</background-video-vimeo>
		</div>

		<div class="row">
			<div class="small-12 columns background-container">
				<div v-bind:style="{ backgroundImage: 'url(' + data.image.src + ')' }" class="background  swipe-in-target"></div>

				<div class="hero-background__content">
					<h2 v-if="data.subtitle" v-html="data.subtitle"></h2>
					<h1 v-html="data.title"></h1>
					<h3 v-if="data.ingress" v-html="data.ingress"></h3>

					<div v-if="data.downloads" >
						<div class="hero-download" v-for="(download, index) in data.downloads" :key="'hero-download-' + index">
							<a :href="download.file.url" class="button button-download icon-download" target="_blank" download v-html="download.title"></a>
						</div>
					</div>

					<div v-for="link in data.links" :key="link.id">
						<button-boxed
							:route="link.route" 
							:href="link.href"
							:text="link.text" 
							:hideText="link.hide_text" 
							:isDark="true"
							:hasArrow="false"
							:arrowLeft="false">
						</button-boxed>
					</div>

					<!-- <link-arrow 
						v-if="data.show_link" 
						:route="data.link.route" 
						:href="data.link.href"
						:text="data.link.text" 
						:hideText="data.link.hide_text" 
						:isDark="linkColorMode"
						:arrowLeft="true">
					</link-arrow> -->
					
				
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import BaseBlock from '@/components/blocks/Base'
export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'hero-background',
		}
	},
	computed: {
		videoObject() {
			return {
				youtube_video_id: this.data.youtube_video_id,
				text: this.data.button_label
			}
		},
		hasLocalVideo() {
			return this.data.local_video ? 'has-video' : ''
		}
	},
	components: {
		// LinkArrow: () => import('dc-vue-default/src/components/global/ui/LinkArrowDynamic'),
		ButtonBoxed: () => import('@/components/global/ui/Button'),
		BackgroundVideo: () => import('dc-vue-default/src/components/global/parts/VideoLocal'),
		BackgroundVideoVimeo: () => import('@/components/global/parts/BackgroundVideoVimeo'),
		VideoDefault: () => import('@/components/blocks/media/Video'),
	},
	mounted() {
		// Used for making the hamburger white for Hero Background on specified breakpoint
		document.querySelector('header').classList.add('background-hero');
	}
}
</script>

<style lang="scss">
	@import "~@/styles/scss/component/hero-background";
</style> 
